export default "__VITE_ASSET__e40eb60a__"